import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { UserRoleResponse, UserRoleCreateRequest, UserRoleUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper } from '../utils';
import { UserRoleDetailsSectionHandler } from './details.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { UserRoleRightsSectionHandler } from './rights.section';
import { InlinePoliciesSectionHandler } from './inline-policies.section';

@RegisterEntityHandler('userrole')
@Injectable()
export class UserRoleHandler extends EntityHandler<UserRoleResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listUserRoles/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.accounts.listUserRoles(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'userrole',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.USERROLES'),
        }));
    }

    getEntity(id: string): Promise<UserRoleResponse> {
        return this.admin.getCached(`getUserRole/${id}`, api => api.accounts.getUserRole(id), 10);
    }

    createEntity(ownerId: string, entity: UserRoleCreateRequest): Promise<UserRoleResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.accounts.createUserRole(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return state === 'deleted' ? this.admin.applyUpdate(api => api.accounts.deleteUserRole(entity.id)) : Promise.reject('Only deletion supported');
    }    

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.USERROLE.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', ICONS.userrole),
            grid.TextColumn('description', 'DESCRIPTION'),
            grid.TimeAgoColumn('modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<UserRoleResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new UserRoleDetailsSectionHandler(this.admin, ownerId),
                new UserRoleRightsSectionHandler(this.admin, ownerId),
                new InlinePoliciesSectionHandler(this.admin, ownerId),
            ],
        },
        // TODO: add this back when we can make sense of the required RQL query
        // {
        //     name: this.admin.i18n.instant('ADMIN.ENTITIES.USERS'),
        //     sections: [
        //         new UserListSectionHandler(this.admin, ownerId, entity),
        //     ],
        // }
        ]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: UserRoleUpdateRequest, sections: FormSectionHandler<UserRoleResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'userrole',
            entity: {}, // set up some defaults if you want
            sections: [
                new UserRoleDetailsSectionHandler(this.admin, ownerId),
                new UserRoleRightsSectionHandler(this.admin, ownerId),
            ],
        });
    }

}












